import { SET_PURCHASES } from '../constants/purchases';

const initialState = {
  list: [],
};

const purchasesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PURCHASES:
      return {
        ...state,
        list: action.list.map(
          p => {
            p.title=p.offer.title;
            p.difficulty=p.offer.difficulty;
            p.tonality=p.offer.tonality;
            p.author=p.offer.author;
            p.author_id=p.offer.user_created;
            return p;
          }
        ),
      };
    default:
      return state;
  }
};

export default purchasesReducer;